export function exportCsv(prefix: string, data: Record<string, any>) {
    const timestamp = new Date().toLocaleDateString().replace(/\//g, '-');
    const filename = `${prefix}-${timestamp}.csv`;

    const keys = Object.keys(data[0]);
    const rows = data.map(element => {
        const values = keys.map(key => {
            const value = element[key];
            // Escape quotes and commas
            if (typeof value === 'string') {
                return `"${value.replace(/"/g, '""')}"`;
            }
            return `"${String(value || '')}"`;
        });
        return values.join(',');
    });

    const csvContent = `${keys.join(',')}\n${rows.join('\n')}`;
    const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}